import {useHistory} from '@aboutyou/router';
import {useIsConsentBannerClosed, useSessionStorage} from '@aboutyou/storage';
import {useManualTimeout} from '@aboutyou/ui-components';
import {useEffect, useState} from 'react';

export const AUTO_OPEN_AFTER = 2000;
const AUTO_CLOSE_AFTER = 6000;

export const useAutoOpenSlideInWebCouponBanner = () => {
  const history = useHistory();
  const isConsentBannerClosed = useIsConsentBannerClosed();
  const [isOpen, setIsOpen] = useState(false);

  const [wasAutoOpened, setWasAutoOpened] = useSessionStorage({
    key: 'was_desktop_web_coupon_banner_opened',
    defaultValue: false,
  });

  const [shouldAutoOpen, startAutoOpenTimer] =
    useManualTimeout(AUTO_OPEN_AFTER);
  const [shouldAutoClose, startAutoCloseTimer] = useManualTimeout(
    AUTO_OPEN_AFTER + AUTO_CLOSE_AFTER,
  );

  useEffect(() => {
    if (isConsentBannerClosed) {
      startAutoOpenTimer();
      startAutoCloseTimer();
    }
  }, [isConsentBannerClosed]);

  const open = () => {
    setIsOpen(true);
  };

  const close = () => {
    setIsOpen(false);
    setWasAutoOpened(true);
  };

  useEffect(() => {
    if (wasAutoOpened) {
      return;
    }

    const removeListener = history.listen(close);

    if (shouldAutoOpen) {
      open();
    }

    if (shouldAutoClose) {
      close();
      removeListener();
    }

    return () => {
      removeListener();
    };
  }, [shouldAutoOpen, shouldAutoClose]);

  return {isOpen};
};
